import { Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import SideNavigation from "./_cmp/SideNavigation";
import { campaignService } from "@/app/_services/CampaignService";
import DeleteDialog from "./_cmp/DeleteDialog";
import BuzzTitle from "./_cmp/BuzzTitle";
import { EmailDialog } from "@/app/admin/marketing/_cmp/emailForm/EmailDialog";

export default function DashLayout() {
  const { campaignId } = useParams<{ campaignId: string }>();
  const router = useNavigate();

  const [campaign, setCampaign] = useState<any>();
  const [deleteDialogOpen, setDeleteDialogopen] = useState(false);
  const [addContentOpen, setAddContentOpen] = useState(false);

  useEffect(() => {
    getCampaign();
  }, [campaignId]);

  const handleClose = () => {
    router(-1);
  };

  async function getCampaign() {
    if (!campaignId) return;
    const c = await campaignService.getCampaignAsync(campaignId);
    setCampaign(c);
  }

  const handleDeleteDialogOpen = () => {
    setDeleteDialogopen(true);
  };
  const handleDeleteDialogClose = () => {
    setDeleteDialogopen(false);
  };

  return (
    <Grid container sx={{ width: "100%" }}>
      <Grid container justifyContent={"center"}>
        <SideNavigation campaignId={campaignId ?? ""} />
        <Grid
          flex={1}
          container
          alignContent={"start"}
          sx={{ justifyContent: "center", background: "white" }}
          p={"5px"}
        >
          <Grid container sx={{ maxWidth: "900px", width: "100%" }}>
            {campaign && (
              <>
                <Grid container justifyContent={"space-between"}>
                  <BuzzTitle
                    campaign={campaign}
                    handleClose={handleClose}
                    handleDeleteDialogOpen={handleDeleteDialogOpen}
                    onAddContent={() => setAddContentOpen(true)}
                  />
                  <DeleteDialog
                    campaignId={campaign?.id}
                    open={deleteDialogOpen}
                    handleClose={handleDeleteDialogClose}
                  />
                </Grid>

                <Grid
                  container
                  mt={2}
                  mb={2}
                  width={"100%"}
                  alignItems={"start"}
                  alignContent={"start"}
                  pb={2}
                >
                  <Outlet />
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>

      <EmailDialog
        open={addContentOpen}
        onClose={() => setAddContentOpen(false)}
        campaignId={campaignId}
        onCreated={(id) => {
          setAddContentOpen(false);
          router(`/admin/marketing/emails/${id}`);
        }}
      />
    </Grid>
  );
}
